import screenfull from 'screenfull';
import { uaParser } from '@betgames/bg-tools';
import { Store } from '@betgames/bg-state-manager';
import { balanceService } from '@bg-shared/business/Balance';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { analyticsApi } from '@bg-shared/business/Analytics';
import { iframeIntegration } from '@bg-shared/integrations';

export class FullScreenStore extends Store<boolean> {
    private readonly CONTAINER = document.body;

    public isSupported = screenfull.isEnabled && !uaParser.isTablet;

    constructor() {
        super({
            key: 'FullScreen',
            default: false,
        });

        if (this.isSupported) {
            screenfull.on('change', () => {
                this.update(screenfull.isFullscreen);

                if (partnerSettingsStore.showBalance) {
                    return;
                }

                if (screenfull.isFullscreen) {
                    balanceService.runEvents();
                } else {
                    balanceService.stopEvents();
                }
            });
        }
    }

    public toggle(value = !this.value, options?: FullscreenOptions): void {
        analyticsApi.trackFullScreenSwitch(value);
        iframeIntegration.fullscreen(value);
        screenfull.toggle(this.CONTAINER, options).catch((err) => {
            console.error('Something went wrong with FullScreen', err);
        });
    }
}

export const fullScreenStore = new FullScreenStore();
